import { SidebarContent } from "./sidebar";

export function Content() {
  return <SidebarContent />;
}
